var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(_setup.InfoCard, { attrs: { title: _vm.title } }, [
    _c(
      "div",
      {
        staticClass: "documents-section",
        attrs: { "data-qa": "documents_section" },
      },
      [
        !_vm.isMobile
          ? _c(_setup.CoreImageLightbox, {
              ref: "lightboxRef",
              attrs: { items: _vm.items },
            })
          : _vm._e(),
        _vm._v(" "),
        !_vm.isMobile
          ? _c(
              "div",
              {
                staticClass: "documents-section__grid d-flex flex-wrap",
                attrs: { "data-qa": "documents_section_grid" },
              },
              _vm._l(_vm.items, function (item, index) {
                return _c(_setup.DocumentCard, {
                  key: item.id ?? `${item.src}-${index}`,
                  staticClass: "documents-section__card ma-4 ml-0 mt-0",
                  attrs: { item: item },
                  on: {
                    open: function ($event) {
                      return _setup.open(index)
                    },
                  },
                })
              }),
              1
            )
          : _c(_setup.CoreImageSlider, {
              staticClass: "documents-section__slider",
              attrs: {
                items: _vm.items,
                "has-navigation": _vm.items.length > 1,
                "has-pagination": _vm.items.length > 1,
                "data-qa": "documents_section_slider",
              },
              scopedSlots: _vm._u([
                {
                  key: "item",
                  fn: function ({ item, open: openSlide }) {
                    return [
                      _c(
                        "article",
                        {
                          staticClass: "documents-section__slider-item",
                          attrs: {
                            "data-qa": "documents_section_slider_item",
                            "data-qa-id": item.id,
                          },
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "documents-section__slider-button",
                              attrs: {
                                type: "button",
                                "data-qa": "documents_section_slider_button",
                              },
                              on: {
                                click: function ($event) {
                                  return openSlide()
                                },
                              },
                            },
                            [
                              _c("img", {
                                staticClass:
                                  "documents-section__slider-image w-100",
                                attrs: {
                                  src: item.previewSrc || item.src,
                                  alt: item.alt || item.title || "",
                                  title: item.title || undefined,
                                  loading: "lazy",
                                },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "text-body-2 text-secondary--text text-center mt-3",
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(item.title) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  },
                },
              ]),
            }),
        _vm._v(" "),
        _vm.updatedDate
          ? _c(
              "p",
              {
                staticClass: "text-body-2 text-info--text text-right mt-2 mb-0",
                attrs: { "data-qa": "documents_section_updated_date" },
              },
              [_vm._v("\n      " + _vm._s(_vm.updatedDate) + "\n    ")]
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }